// Initialize Datadog once, before React hydration

import { getDatadogConfig, getVyEnvUnsafe } from "./utils";

export const initDatadog = () => {
  const vyEnv = getVyEnvUnsafe();

  // Skip in local development
  if (vyEnv === "local") {
    console.log(
      `Skipping Datadog browser logs initialization in env: ${vyEnv}`,
    );
    return;
  }

  const datadogConfig = getDatadogConfig();

  if (!datadogConfig) {
    console.warn("Datadog config missing, skipping initialization");
    return;
  }

  import("@datadog/browser-logs")
    .then(({ datadogLogs }) => {
      datadogLogs.init({
        clientToken: datadogConfig.clientToken,
        service: datadogConfig.service,
        site: "datadoghq.eu",
        sessionSampleRate: 100,
        env: vyEnv,
        // Start with forwarding all console logs. If we want to scope down what logs we send, opt for `tLogger` instead.
        forwardConsoleLogs: "all",
        forwardErrorsToLogs: true,
        forwardReports: "all",
      });

      console.log("Datadog browser logs initialized.");
    })
    .catch((error) => {
      console.warn("Failed to initialize datadog browser logs:", error);
    });
};
